import React, { useState } from "react";
import { conciergeAuthFetch } from "../../../../utils/conciergeCmsAuth";

export default function ConciergeUserChangePin() {
  const [pin, setPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (!/^\d{6}$/.test(pin)) {
      setError("핀번호는 6자리 숫자여야 합니다.");
      return;
    }
    if (pin !== confirmPin) {
      setError("핀번호 확인이 일치하지 않습니다.");
      return;
    }

    try {
      setLoading(true);
      setError("");
      setDone(false);
      const res = await conciergeAuthFetch("/concierge/user/change-pin", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ new_pin: pin }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.detail || "핀번호 변경에 실패했습니다.");
      setDone(true);
      setPin("");
      setConfirmPin("");
    } catch (err) {
      setError(err.message || "핀번호 변경에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-8 py-8">
      <h1 className="text-2xl font-bold text-[#111827]">핀번호 변경</h1>
      <div className="mt-6 max-w-[540px] rounded-2xl border border-[#ebeef5] bg-white p-6">
        <form className="space-y-4" onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="새 핀번호 6자리"
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))}
            className="h-11 w-full rounded-lg border border-[#e5e7eb] px-4 text-sm outline-none focus:border-[#7864F9]"
          />
          <input
            type="password"
            placeholder="새 핀번호 확인"
            value={confirmPin}
            onChange={(e) => setConfirmPin(e.target.value.replace(/\D/g, "").slice(0, 6))}
            className="h-11 w-full rounded-lg border border-[#e5e7eb] px-4 text-sm outline-none focus:border-[#7864F9]"
          />

          {error ? <div className="text-xs text-red-500">{error}</div> : null}
          {done ? <div className="text-xs text-emerald-600">핀번호가 변경되었습니다.</div> : null}

          <button
            type="submit"
            disabled={loading}
            className="h-11 rounded-lg bg-[#7864F9] px-5 text-sm font-semibold text-white disabled:opacity-60"
          >
            저장
          </button>
        </form>
      </div>
    </div>
  );
}

